import { decryptCredentials } from '../cifrate';

export const PLANS = {
  NRO_PLAN_RS_BASICO: decryptCredentials(process.env.REACT_APP_NRO_PLAN_RS_BASICO),
  NRO_PLAN_RS_ESTANDAR: decryptCredentials(process.env.REACT_APP_NRO_PLAN_RS_ESTANDAR),
  NRO_PLAN_RS_COMPLETO: decryptCredentials(process.env.REACT_APP_NRO_PLAN_RS_COMPLETO),
  NRO_PLAN_RS_PLUS: decryptCredentials(process.env.REACT_APP_NRO_PLAN_RS_PLUS),
  COD_PLAN_BASICO: decryptCredentials(process.env.REACT_APP_COD_PLAN_BASICO),
  COD_PLAN_ESTANDAR: decryptCredentials(process.env.REACT_APP_COD_PLAN_ESTANDAR),
  COD_PLAN_COMPLETO: decryptCredentials(process.env.REACT_APP_COD_PLAN_COMPLETO),
  COD_PLAN_PLUS: decryptCredentials(process.env.REACT_APP_COD_PLAN_PLUS),
};
